interface NewBadgeIconProps {
  className?: string;
}

export const NewBadgeIcon = ({ className }: NewBadgeIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="16" height="16" rx="8" fill="#FF7A14" />
      <path
        d="M10.8978 11.5359H9.62707L6.51934 7.04353H6.46754V11.5359H5V4.46411H6.29144L9.375 8.95306H9.43715V4.46411H10.8978V11.5359Z"
        fill="white"
      />
    </svg>
  );
};
